import React, { PropsWithChildren } from 'react';
import { createUseStyles } from 'react-jss';
import Popper from '../../components/Popper';
import ClickAwayListener from './ClickAwayListener';

interface Props<T> {
  isOpen: boolean;
  dropdownRef: any;
  list: T[];
  onClose: () => void;
  renderDropDownItem: (item: T, key: number) => any;
  title?: string;
  loading: boolean;
  emptyText: string;
}

const useStyles = createUseStyles({
  root: {
    zIndex: 40,
  },
  menu: {
    width: 350,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    boxShadow: '0 0 35px 0 rgba(154,161,171,.15)',
    padding: '.25rem 0',
    border: '1px solid #e4eaf2',
    borderRadius: '.25rem',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 230,
    overflow: 'auto',
    margin: '15px 10px',
  },
  menuTitle: {
    fontWeight: 700,
    fontSize: '.9rem',
  },
  alignCenter: {
    padding: '7px 20px',
    textAlign: 'center',
  },
});

function DropDownList<T>({
  isOpen,
  onClose,
  dropdownRef,
  renderDropDownItem,
  emptyText,
  list,
  title,
  loading,
}: PropsWithChildren<Props<T>>) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {dropdownRef && isOpen && (
        <Popper anchorEl={dropdownRef}>
          <ClickAwayListener onClickAway={onClose}>
            <div className={classes.menu}>
              {title && <div className={classes.menuTitle}>{title}</div>}

              {loading ? (
                <div className={classes.alignCenter}>Chargement ...</div>
              ) : (
                list.length <= 0 && <div className={classes.alignCenter}>{emptyText}</div>
              )}

              {list.length > 0 && <div className={classes.list}>{list.map(renderDropDownItem)}</div>}
            </div>
          </ClickAwayListener>
        </Popper>
      )}
    </div>
  );
}

export default DropDownList;
